import React from "react";

interface IPlanOfferingsBlock {
  title?: string;
  children: any;
}

export default function PlanOfferingsBlock({ title, children }: IPlanOfferingsBlock) {
  return (
    <div
      css={{
        display: "grid",
        gridRowGap: 10,
      }}
    >
      {title && (
        <h5
          css={{
            color: "#525252",
            fontWeight: 600,
            fontSize: 14,
            margin: 0,
          }}
        >
          {title}
        </h5>
      )}

      {children}
    </div>
  );
}
